import { combineReducers } from 'redux'

import items    from './items'
import auth     from './auth'
import features from './features'
import settings from './settings'

export default combineReducers({
  items,
  auth,
  features,
  settings,
})